// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseMemberEntity from './entities/case-member.json';
import caseMemberMenu from '../pages/case-member/menu.json';
import caseMemberFullForm from '../pages/case-member/forms/full.json';
import caseMemberContextForm from '../pages/case-member/forms/context.json';
import caseMemberMiniForm from '../pages/case-member/forms/mini.json';
import caseMemberLookupForm from '../pages/case-member/forms/lookup.json';
import caseMemberTableView from '../pages/case-member/views/table.json';
import caseMemberCardsView from '../pages/case-member/views/cards.json';
import caseMemberCalendarView from '../pages/case-member/views/calendar.json';
import caseMemberDashboardView from '../pages/case-member/views/dashboard.json';

/** Тип запису «Учасник справи» зі сторінками пакета: меню, форми та подання з pages/case-member/. */
export const caseMemberDefinition: IRecordTypeDefinition = {
  ...caseMemberEntity,
  views: assembleViewSet({
      table: caseMemberTableView,
      cards: caseMemberCardsView,
      calendar: caseMemberCalendarView,
      dashboard: caseMemberDashboardView,
  }),
  form: caseMemberFullForm,
  forms: { full: caseMemberFullForm, context: caseMemberContextForm, mini: caseMemberMiniForm, lookup: caseMemberLookupForm },
  menu: caseMemberMenu,
} as IRecordTypeDefinition;
